import { create } from 'zustand';

export interface Toast {
  id: number;
  message: string;
  color: 'success' | 'danger' | 'warning' | 'medium';
}

interface UiState {
  toasts: Toast[];
  push: (message: string, color?: Toast['color']) => void;
  dismiss: (id: number) => void;
}

let toastId = 0;

export const useUiStore = create<UiState>((set) => ({
  toasts: [],
  push: (message, color = 'medium') => {
    const id = ++toastId;
    set((state) => ({ toasts: [...state.toasts, { id, message, color }] }));
    // Auto-expire; ToastHost renders and dismisses visually.
    setTimeout(() => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })), 4_000);
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));

export const toast = (message: string, color: Toast['color'] = 'medium'): void =>
  useUiStore.getState().push(message, color);
